import { Api } from '../../legacy/utils/api'
import _memoize from 'lodash/memoize'

const _tollwaysApi = new Api(Api.BASE_URL.B2B)

const fetchGetTollways = _memoize(() =>
  _tollwaysApi.request('get', '/tollways')
)
setInterval(() => fetchGetTollways.cache.clear(), 10 * 60 * 1000)

const tollwaysService = {
  getTollways: async () => {
    try {
      const result = await fetchGetTollways()
      return result.data
    } catch (error) {
      throw error
    }
  },
}

export { tollwaysService }
